module.exports = __webpack_public_path__ + "static/003.bf04f235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image/003.jpg
// module id = 1220
// module chunks = 35783957827783